var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"message-modal",attrs:{"title":"标题","buttonsHidden":""}},[_vm._v("\n  这是二级弹框\n")])}
var staticRenderFns = []

export { render, staticRenderFns }